/*
 * File: src/router/page/register/Welcome.tsx
 * Notes:
 *   > ...
 */

import React, { FunctionComponent } from "react";
import Typography from "@material-ui/core/Typography";
import makeStyles from "@material-ui/core/styles/makeStyles";
import useTextHighlightStyles from "../../../styles/useTextHighlightStyles";
import MuiLink from "@material-ui/core/Link";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  spacing: {
    marginBottom: theme.spacing(4),
  },
}));

const ThankYouOnlineAccess: FunctionComponent = () => {
  const classes = useStyles();
  const textClasses = useTextHighlightStyles();

  return (
    <>
      <Typography
        variant="h4"
        className={`${classes.spacing} ${textClasses.textHighlightBlue}`}
      >
        Welcome to CLYNK Online Access!
      </Typography>
      <Typography>
        With{" "}
        <span className={textClasses.textHighlightBlue}>
          CLYNK Online Access
        </span>{" "}
        you can login to your CLYNK account from your mobile phone or computer
        at <MuiLink href="https://clynk.com">clynk.com</MuiLink> to:
      </Typography>
      <ul>
        <Typography component="li">
          Check your balance on your computer or smart phone
        </Typography>
        <Typography component="li">
          See how many containers you’ve CLYNKed
        </Typography>
        <Typography component="li">
          Understand how your recycling through CLYNK has impacted the
          environment
        </Typography>
        <Typography component="li">Update your account information</Typography>
        <Typography component="li">
          Change your PIN without having to call Customer Support
        </Typography>
        <Typography component="li">
          Donate money from your account to local charities
        </Typography>
      </ul>
      <MuiLink
        component={Link}
        to="/login"
        className={textClasses.textHighlightBlue}
      >
        Log in
      </MuiLink>{" "}
      now!
    </>
  );
};

export default ThankYouOnlineAccess;
